<ng-container [ngSwitch]="stepFromUrl$ | async">
    <ng-container *ngIf="dataFromUrl$ | async as dataFromUrl">
        <ng-container *ngIf="!isPurchaseByCard">
            <gl-purchase-v2-ticket-preferences
                *ngSwitchCase="'preferences'"
                [preferences]="preferences$ | async"
                [selectedPreferenceId]="dataFromUrl?.selectedPreferenceId"
                [savedPreference]="savedPreference$ | async"
                (nextStep)="handleNextClicked()"
                (nextButtonElement)="handleNextButtonElement($event)"
                (savePreference)="handleSavePreference($event)"
                (selectedOptionChange)="handleSelectedPreferenceChange($event)">
            </gl-purchase-v2-ticket-preferences>
        </ng-container>
        <gl-purchase-v2-ticket-areas
            *ngSwitchCase="'areas'"
            [areas]="areas$ | async"
            [selectedAreaId]="dataFromUrl?.selectedAreaId"
            (nextStep)="handleNextClicked()"></gl-purchase-v2-ticket-areas>
        <ng-container *ngIf="productAreas$ | async as productAreas">
            <gl-purchase-v2-ticket-product-areas
                *ngSwitchCase="'product-area'"
                [selectedArea]="selectedArea$ | async"
                [productAreas]="productAreas"
                [selectedProductAreas]="dataFromUrl"
                [selectedOption]="selectedPreferenceOption$ | async"
                (nextStep)="handleNextClicked()"
                (nextButtonElement)="handleNextButtonElement($event)"
                (errorEvent)="handleErrorEvent($event)"></gl-purchase-v2-ticket-product-areas>

            <gl-purchase-v2-ticket-category-product
                *ngSwitchCase="'category-product'"
                [productAreas]="productAreas"
                [selectedProductId]="dataFromUrl?.selectedProductId"
                (nextStep)="handleNextClicked()"
                (errorEvent)="handleErrorEvent($event)"></gl-purchase-v2-ticket-category-product>

            <gl-purchase-v2-ticket-product
                *ngSwitchCase="'product'"
                [productAreas]="productAreas"
                [ticketsFromUrl]="dataFromUrl"
                [activationMode$]="activationMode$"
                [selectedStartingDate$]="selectedStartingDate$"
                [ActivationMode]="ActivationMode"
                [minDate]="minDate"
                (nextStep)="handleNextClicked()"
                (nextButtonElement)="handleNextButtonElement($event)"
                (errorEvent)="handleErrorEvent($event)"
                (activationModeChange)="onActivationModeChange($event)"
                (dateChange)="onDateChange($event)">
            </gl-purchase-v2-ticket-product>

            <gl-purchase-v2-ticket-activation
                *ngSwitchCase="'ticket-activation'"
                [categoryProducts]="categoryProducts"
                [productAreas]="productAreas"
                (nextButtonElement)="handleNextButtonElement($event)"
                (nextStep)="handleNextClicked()"></gl-purchase-v2-ticket-activation>
        </ng-container>
    </ng-container>
</ng-container>
